import {
  GET_WORKORDERS,
  GET_WORKORDERS_SUCCESS,
  GET_WORKORDERS_FAIL,
  ADD_WORKORDER,
  ADD_WORKORDER_SUCCESS,
  ADD_WORKORDER_FAIL,
  UPDATE_WORKORDER,
  UPDATE_WORKORDER_SUCCESS,
  UPDATE_WORKORDER_FAIL,
  DELETE_WORKORDER,
  DELETE_WORKORDER_SUCCESS,
  DELETE_WORKORDER_FAIL,
  SET_WORKORDER_FIELD_ERRORS,
} from './actionTypes'

const initialState = {
  workorders: [],
  loading: false,
  error: null,
  status: null,
  fieldErrors: {}, // Store field-specific errors
}

const workOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_WORKORDERS:
      return { ...state, loading: true }
    case GET_WORKORDERS_SUCCESS:
      return { ...state, loading: false, workorders: action.payload, error: null }
    case GET_WORKORDERS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case ADD_WORKORDER:
      return { ...state, loading: true }
    case ADD_WORKORDER_SUCCESS:
      return { ...state, loading: false, status: 'success', fieldErrors: {} }
    case ADD_WORKORDER_FAIL:
      return { ...state, loading: false, error: action.payload }

    case UPDATE_WORKORDER:
      return { ...state, loading: true }
    case UPDATE_WORKORDER_SUCCESS:
      return { ...state, loading: false, fieldErrors: {} }
    case UPDATE_WORKORDER_FAIL:
      return { ...state, loading: false, error: action.payload }

    case DELETE_WORKORDER:
      return { ...state, loading: true }
    case DELETE_WORKORDER_SUCCESS:
      return { ...state, loading: false }
    case DELETE_WORKORDER_FAIL:
      return { ...state, loading: false, error: action.payload }

    case SET_WORKORDER_FIELD_ERRORS:
      return { ...state, fieldErrors: action.payload }

    default:
      return state
  }
}

export default workOrderReducer
